export default "__VITE_ASSET__CzQgSxCj__"